import {createSvgIcon} from '../create-svg-icon';

export const BoyIcon = createSvgIcon(
  <path d="M12 7.5c.97 0 1.75-.78 1.75-1.75S12.97 4 12 4s-1.75.78-1.75 1.75S11.03 7.5 12 7.5zM14 20v-5h1v-4.5c0-1.1-.9-2-2-2h-2c-1.1 0-2 .9-2 2V15h1v5h4z" />
, 'BoyOutlined');
